import React, { useContext } from "react"
import { Link } from "gatsby"

import MicrocopyContext from "~contexts/MicrocopyContext"
import * as style from "./RelatedLinks.module.scss"

const RequiredPages = ({
  pages = [],
  endpoints = [],
  title,
  divider = false,
}) => {
  const microcopy = useContext(MicrocopyContext)

  return (
    <>
      {(endpoints?.[0] || pages?.[0]) && (
        <div className={style.related_links} data-divider={divider}>
          <h1>{title}</h1>
          <ul>
            {pages.map((page) => (
              <li key={page.id}>
                <Link to={page.path}>
                  <span className={style.type} data-page={page.type}>
                    {page.type === "quick-start"
                      ? microcopy.text("guides.titles.quick_start_guide")
                      : microcopy.text("guides.titles.guide")}
                  </span>
                  <span className={style.title}>{page.title}</span>
                </Link>
              </li>
            ))}
            {endpoints.map((endpoint) => (
              <li key={endpoint.id}>
                <Link to={endpoint.path}>
                  <span className={style.type} data-verb={endpoint.verb}>
                    {endpoint.verb}
                  </span>
                  <span className={style.title}>{endpoint.title}</span>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      )}
    </>
  )
}

export default RequiredPages
